export default "__VITE_ASSET__c1c3b017__$_?react__"